import React, { Fragment } from "react";
import * as Yup from "yup";
import * as yupSchema from "../../../constants/schema";
import { useErrorHandler } from "../../../hooks";
import glassesService from "../../../services/glasses.service";
import DialogFormBuilder from "../../../components/dialog-form-builder";
import { useMemo } from "react";
import {
  DialogContent,
  Divider,
  Grid,
  TextField,
  Typography,
} from "@material-ui/core";

const FormWrapper = ({ children }) => (
  <DialogContent>
    {children}
    {/* <Grid container spacing={2} alignItems={"center"}>
      {children}
    </Grid> */}
  </DialogContent>
);

export default function InventoryChangeModalContent({ close, data, extra }) {
  const { colors = [] } = data;
  const errorHandler = useErrorHandler();

  const schema = useMemo(() => {
    const obj = {};
    colors.forEach((color) => {
      color.sizes.forEach((size) => {
        obj[size.id] = yupSchema.typeCreator("تعداد", {
          type: "number",
          min: -size.count,
        });
      });
    });
    return Yup.object().shape(obj);
  }, [colors]);
  const initialValues = useMemo(() => {
    const obj = {};
    colors.forEach((color) => {
      color.sizes.forEach((s) => {
        obj[s.id] = 0;
      });
    });
    return obj;
  }, [colors]);

  const form = useMemo(
    () => [
      ...colors
        .filter((c) => c.sizes.length)
        .map((c, idx) => {
          return {
            _type: "container",
            name: "col" + idx,
            _wrapper: ({ children, ...other }) => (
              <div {...other}>
                {idx ? <Divider className="mb-3 mt-2" /> : null}
                <Typography fontWeight={500} variant="h6">
                  رنگ: {c.name}
                </Typography>
                <Grid spacing={2} alignItems={"center"} container>
                  {children}
                </Grid>
              </div>
            ),
            form: [
              ...c.sizes.map((size, idx) => {
                return {
                  _type: "container",
                  name: "col" + idx,
                  // _wrapper: ({ children, ...other }) => (
                  //   <div {...other}>
                  //     <Typography>رنگ: {c.name}</Typography>
                  //     <Grid item xs={12} container>
                  //       {children}
                  //     </Grid>
                  //   </div>
                  // ),
                  form: [
                    {
                      _type: "customContent",
                      content: () => {
                        return (
                          <Fragment key={idx}>
                            <Grid item xs={4}>
                              {/* <Typography>
                                {size.lensSize}-{size.bridgeSize}
                              </Typography> */}
                              <TextField
                                label="سایز"
                                margin="normal"
                                value={
                                  size.hingeToHinge > 139
                                    ? "بزرگ"
                                    : size.hingeToHinge < 130
                                    ? "کوچک"
                                    : "متوسط"
                                }
                                // value={
                                //   size.name ||
                                //   `${size.lensSize}-${size.bridgeSize}`
                                // }
                                // readOnly
                                disabled
                                variant="outlined"
                              />
                            </Grid>
                            <Grid item xs={4}>
                              {/* <Typography>{c.count}</Typography> */}
                              <TextField
                                label="موجودی فعلی"
                                margin="normal"
                                value={size.count}
                                // readOnly
                                disabled
                                variant="outlined"
                              />
                            </Grid>
                          </Fragment>
                        );
                      },
                    },
                    {
                      _wrapper: (props) => (
                        <Grid
                          // key={size.id}
                          item
                          xs={4}
                          {...props}
                        />
                      ),
                      _type: "textField",
                      name: size.id,
                      type: "number",
                      label: "مقدار افزایش",
                      // inputProps: {
                      //   min: -c.count,
                      // },
                    },
                  ],
                };
              }),
            ],
          };
        }),
    ],
    [colors]
  );

  const handleSubmit = async (_model, { setSubmitting }) => {
    const model = {
      items: Object.entries(_model).map(([id, count]) => ({ id, count })),
    };

    const { error } = glassesService.updateStocks(model);

    setSubmitting(false);
    if (error) return errorHandler(error);

    close(true);
  };
  return (
    <DialogFormBuilder
      {...{
        close,
        title: "تغییر موجودی",
        schema,
        initialValues,
        handleSubmit,
        form,
        formWrapper: FormWrapper,
        submitLabel: "ذخیره",
      }}
    />
  );
}
